module.exports = __webpack_public_path__ + "static/img/iq.be991997.svg";